<template>
    <div class="page-box">
      <Header/>
      <div class="mg-bottom-70 bg-color-EAF1FA">
        <TopBanner :top-banner-img="BannerImg" :titleStyle="{fontSize: '32px'}" title2="生意助手SCRM" title-row2="增强在数字化竞争环境下的" blue-text="核心竞争力和商业成功" :tips-flex="true" :title-tips-list="titleTipsList" :contentStype="{paddingTop: '176px'}">
          <div class="top-banner-tips">
            提供全方位的客户关系管理工具、智能化的交互手段以及跨渠道数据整合能力，<br/>实现交易转化率的提升、客户关系的深度经营以及数据驱动的精准营销
          </div>
        </TopBanner>
      </div>
      <!-- 经营痛点 -->
      <div class="mg-bottom-100">
        <ModuleTitle data-aos="fade-up" bg-color="#fff" title="经营痛点" :moduleTipsList="[{name: '数字化转型中的卖家在交易转化、客户互动以及数据整合方面面临显著挑战'}]" />
        <ModuleCenter >
            <div class="flex-box" data-aos="fade-up">
              <CardItem v-for="(item, index) in painList" :key="index" :item="item" :cardStyle="cardStyle"></CardItem>
            </div>
        </ModuleCenter>
      </div>
      <!-- SCRM助力企业全渠道营销自动化 -->
      <div class="goods-manage">
        <ModuleTitle data-aos="fade-up" title="SCRM助力企业全渠道营销自动化" :moduleTipsList="[{name: '搭建企业私域流量池，深度运营各渠道社交生态'}]" />
        <ModuleCenter>
          <div class="flex-box" style="margin-bottom: 100px;" data-aos="fade-up">
            <div class="goods-manage-left goods-manage-item">
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content" style="width:250px">
                  <span class="item-ilne-title">多渠道引流沉淀</span>
                  <div>多渠道引流、渠道活码、好友欢迎语、快捷回复</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content" style="width:250px">
                  <span class="item-ilne-title">运营服务</span>
                  <div>提供私域培训、及部分托管代运营服务</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content" style="width:250px">
                  <span class="item-ilne-title">定制化扩展</span>
                  <div>独立系统的扩展、API对接内部各系统、功能营销定制</div>
                </div>
              </div>
            </div>
            <div class="goods-manage-middle">
              <img class="goods-manage-mid-img" style="width: 520px; height: 480px;" src="@/assets/product/digitalSystem/scrmNum1.png" alt="" />
            </div>
            <div class="goods-manage-right goods-manage-item">
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content" style="width:260px">
                  <span class="item-ilne-title">裂变增长获客</span>
                  <div>社群裂变、任务裂变、分销机制</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content" style="width:260px">
                  <span class="item-ilne-title">精细化运营</span>
                  <div>自动打标签、自动拉群、精准群发触达、社群高效管理</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content" style="width:260px">
                  <span class="item-ilne-title">多维数据分析</span>
                  <div>实时客户状态统计、跟进意向数据统计、多平台数据打通、全属性画像分析</div>
                </div>
              </div>
            </div>
          </div>
        </ModuleCenter>
      </div>
      <!-- 全渠道连接客户，挖掘客户价值 -->
      <div class="mg-btm-70 bg-color-0B4FD1">
        <ModuleBgBlue >
          <ModuleCenter >
            <div class="core-advantages pd-top-70">
              <ModuleTitle data-aos="fade-up" title="全渠道连接客户，挖掘客户价值" title-color="#fff" :desc-stype="titleDescStype" :moduleTipsList="[{name: '洞察客户行为，高效跟进客户，赋能企业数字化能力'}]" />
              <div class="flex-box" data-aos="fade-up">
                <CardItem v-for="(item, index) in advantageList" :key="index" :item="item" :card-style="advantageCardStyle" :cardDescStyle="cardDescStyle" :cardDescStyleItem="cardDescStyleItem"></CardItem>
              </div>
            </div>
          </ModuleCenter>
        </ModuleBgBlue>
      </div>
      <!-- 提供私域粉丝统一管理、全生命周期服务 -->
      <ModuleCenter >
          <ModuleTitle data-aos="fade-up" bg-color="#fff" title="提供私域粉丝统一管理、全生命周期服务"  />
          <img class="showImg" data-aos="fade-up" :src="srcmOne" alt="" />
      </ModuleCenter>
      <!-- 多渠道获客 -->
      <div class="pd-top-70 pd-btm-70" style="background-color: #F4F5FB">
        <ModuleCenter>
          <ModuleTitle data-aos="fade-up" bg-color="#fff" title="多渠道获客" :moduleTipsList="[{name: '集成批量添加、智能分配、互动裂变与短信链等多种手段，帮助企业全面覆盖线上与线下、主动与被动的各种获客场景，实现高效、精准且具有高度互动性的客户引流'}]" />
          <div class="flex-box justify-center-start" data-aos="fade-up">
            <div class="goods-manage-middle" style="margin-right: 98px;">
              <img class="goods-manage-mid-img" src="@/assets/product/digitalSystem/scrmNum2.png" style="width:665px;height:392px" alt="" />
            </div>
            <div class="goods-manage-right goods-manage-item">
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content" style="width:370px">
                  <span class="item-ilne-title">多平台批量添加好友</span>
                  <div>获取电商平台数据，批量添加好友，实现千人千面自动回复</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content" style="width:370px">
                  <span class="item-ilne-title">渠道活码，智能分配</span>
                  <div>支持电商、短信、公众号、线下物料等多渠道获客</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content" style="width:370px">
                  <span class="item-ilne-title">互动裂变获客</span>
                  <div>通过营销工具，裂变引流至系统内</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content" style="width:370px">
                  <span class="item-ilne-title">短信链获客</span>
                  <div>通过短信添加企微短链，通过验证后自动发送欢迎语</div>
                </div>
              </div>
            </div>
          </div>
        </ModuleCenter>
      </div>
      <!-- 营销运营 -->
      <div class="goods-manage pd-bottom-100 pd-top-70">
        <ModuleTitle data-aos="fade-up" title="营销运营" :moduleTipsList="[{name: '通过客户分层 客户标签 客户画像 SOP策略 数据分析 跟踪策略制定和执行，提高客户的购买转化率，降低企业销售成本'}]" />
        <ModuleCenter>
          <div class="flex-box" data-aos="fade-up">
            <div class="goods-manage-left goods-manage-item">
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content" style="width:450px">
                  <span class="item-ilne-title">引流拉新</span>
                  <div>利用微信公众号和企业微信的各项功能，实现裂变用户增长</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content" style="width:450px">
                  <span class="item-ilne-title">客户运营</span>
                  <div>客户分层、客户标签画像、客户属性自定义，多方位精细化运营客户</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content" style="width:450px">
                  <span class="item-ilne-title">用户管理</span>
                  <div>建立多层级细化权限的客户管理机制，企业统一管理</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content" style="width:450px">
                  <span class="item-ilne-title">用户营销</span>
                  <div>打通社交软件如微博、微信等，实现免费高效率的群发、朋友圈营销等多种方式的信息触达</div>
                </div>
              </div>
            </div>
            <div class="goods-manage-middle">
              <img class="goods-manage-mid-img" style="width: 640px;height: 436px;" src="@/assets/product/digitalSystem/scrmNum3.png" alt="" />
            </div>
          </div>
        </ModuleCenter>
      </div>
      <!-- 会话存档 -->
      <div class="pd-top-70 pd-btm-70" style="background-color: #F4F5FB">
        <ModuleCenter>
          <ModuleTitle data-aos="fade-up" bg-color="#fff" title="会话存档" :moduleTipsList="[{name: '通过永久存储留存各种聊天数据，实现服务和销售的监管提醒，并通过内容的积累分析实现智能化营销'}]" />
          <div class="flex-box justify-center-start" data-aos="fade-up">
            <div class="goods-manage-middle" style="margin-right: 80px;">
              <img class="goods-manage-mid-img" style="width: 673px;height: 392px;" src="@/assets/product/digitalSystem/srcmNum4.png" alt="" />
            </div>
            <div class="goods-manage-right goods-manage-item">
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content" style="width:400px">
                  <span class="item-ilne-title">会话内容合规存档</span>
                  <div>支持文本/图片/语音/视频/文件/小程序等形式，保留撤回消息</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content" style="width:400px">
                  <span class="item-ilne-title">敏感行为提醒</span>
                  <div>可合法查看员工飞单/辱骂客户/私自承诺/收授红包等违规行为</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content" style="width:400px">
                  <span class="item-ilne-title">事件溯源</span>
                  <div>可将员工和客户的所有聊天记录存档，后续发生纠纷时有据可查</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content" style="width:400px">
                  <span class="item-ilne-title">会话审查/分析</span>
                  <div>可根据聊天频率或聊天深度，智能对客户的意向和质量进行评分</div>
                </div>
              </div>
            </div>
          </div>
        </ModuleCenter>
      </div>
      <!-- 客户CRM -->
      <div class="goods-manage pd-bottom-100 pd-top-70">
        <ModuleTitle data-aos="fade-up" title="客户CRM" :moduleTipsList="[{name: '打通企业微信的智能CRM系统，覆盖售前、售中、售后全流程一体化的客户运营管理平台'}]" />
        <ModuleCenter>
          <div class="flex-box" data-aos="fade-up">
            <div class="goods-manage-left goods-manage-item">
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content" style="width:450px">
                  <span class="item-ilne-title">销售漏斗</span>
                  <div>全渠道获客，销售线索自动入库，客户关系留在企业，各层次客户转化率形成漏斗图</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content" style="width:450px">
                  <span class="item-ilne-title">客户分层</span>
                  <div>根据客户情况和跟踪情况对客户进行分层管理，提高销售效率</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content" style="width:450px">
                  <span class="item-ilne-title">客户公海</span>
                  <div>建立客户回收机制和规则，支持大小公海和部门不同公海功能</div>
                </div>
              </div>
              <div class="goods-manage-ilne">
                <img class="item-ilne-icon" :src="CancelImg" alt="">
                <div class="item-ilne-content" style="width:450px">
                  <span class="item-ilne-title">商机管理</span>
                  <div>销售线索到销售商机的全方位管理，全面管理跟踪客户，不遗漏数据</div>
                </div>
              </div>
            </div>
            <div class="goods-manage-middle">
              <img class="goods-manage-mid-img" style="width: 640px;height: 464px;" src="@/assets/product/digitalSystem/scrmNum5.png" alt="" />
            </div>
          </div>
        </ModuleCenter>
      </div>
      <Footer/>
    </div>
</template>
<script>
import TopBanner from './components/topBanner.vue'
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Banner from '@/assets/product/digitalSystem/banner-6.jpg'
import ModuleTitle from './components/moduleTitle.vue'
import ModuleCenter from './components/moduleCenter.vue'
import ModuleBgBlue from './components/moduleBgBlue.vue'
import CardItem from './components/cardItem.vue'
import Cancel from '@/assets/product/digitalSystem/cancel-icon.png'
import srcmOne from '@/assets/product/digitalSystem/srcmOne.png'
export default {
  components: {
    Footer,
    Header,
    TopBanner,
    ModuleTitle,
    ModuleCenter,
    CardItem,
    ModuleBgBlue,
  },
   data() {
      return {
        BannerImg: Banner,
        CancelImg: Cancel,
        srcmOne: srcmOne,
        titleTipsList: [
          {
            name: '客户画像'
          },
          {
            name: '算法模型'
          },
          {
            name: '客户服务匹配'
          },
          {
            name: '私域运营'
          }
        ],
        titleDescStype: {
          color: '#fff',
          opacity: 0.7
        },
        cardStyle: {
          width: '380px',
          height: '240px',
          padding: '30px 30px 0 30px'
        },
        painList: [
          {
            icon: require("@/assets/product/icon/scrmIcon1.png"),
            name: '交易转化干预不足',
            imgShow: false,
            descList: [
              '无法在关键节点有效干预和引导客户，缺乏对客户行为和偏好的深入理解，或者没有合适的工具和策略来及时响应客户的需求。这种干预的缺失可能导致销售机会的流失。',
            ]
          },
          {
            icon: require("@/assets/product/icon/scrmIcon2.png"),
            name: '互动性差',
            imgShow: false,
            descList: [
              '在与客户的互动中存在不足，尤其是在客户的全生命周期中。有效的互动可以帮助建立和维护与客户的关系，提高客户满意度和忠诚度，促进再次购买和推荐。',
            ]
          },
          {
            icon: require("@/assets/product/icon/scrmIcon3.png"),
            name: '数据孤岛问题',
            imgShow: false,
            descList: [
              '在多渠道销售环境中，各渠道终端的数据往往分散在不同的系统中，形成所谓的“数据孤岛”。这不仅使得数据的收集和分析变得困难，而且限制了数据的有效应用。',
            ]
          },
        ],
        advantageList: [
          {
            icon: require("@/assets/product/icon/scrmIcon4.png"),
            name: '连接客户',
            imgShow: false,
            descList: [
              '抓住一切机会',
              '全渠道链接客户'
            ]
          },
          {
            icon: require("@/assets/product/icon/scrmIcon5.png"),
            name: '客户洞察',
            imgShow: false,
            descList: [
              '对原始数据加工分析',
              '形成全域客户画像'
            ]
          },
          {
            icon: require("@/assets/product/icon/scrmIcon6.png"),
            name: '自动化培育',
            imgShow: false,
            descList: [
              '针对潜在客户',
              '有策略的进行自动化培育'
            ]
          },
          {
            icon: require("@/assets/product/icon/scrmIcon7.png"),
            name: ' 内容营销',
            imgShow: false,
            descList: [
              '配合内容矩阵策略',
              '形成内容带动获客和培育闭环'
            ]
          },
          {
            icon: require("@/assets/product/icon/scrmIcon8.png"),
            name: '全渠道营销',
            imgShow: false,
            descList: [
              '通过微信生态、短信、邮件，外呼中',
              '心等全渠道营销和沟通触达'
            ]
          },
          {
            icon: require("@/assets/product/icon/scrmIcon9.png"),
            name: '生命周期营销',
            imgShow: false,
            descList: [
              '围绕用户生命周期模型',
              '在关键节点进行自动化营销策略'
            ]
          },
          {
            icon: require("@/assets/product/icon/scrmIcon10.png"),
            name: '客户旅程',
            imgShow: false,
            descList: [
              '配合自动化营销引擎',
              '打造个性化体验'
            ]
          },
          {
            icon: require("@/assets/product/icon/scrmIcon11.png"),
            name: '活动营销',
            imgShow: false,
            descList: [
              '多样的营销活动类型，对每一次活',
              '动、计划和监控提供完整的管理'
            ]
          }
        ],
        advantageCardStyle: {
          backgroundColor: '#fff',
          height: '210px',
          width:'285px',
          padding: '30px 30px',

        },
        cardDescStyle: {
          textAlign: 'center',
        },
        cardDescStyleItem: {
          display: 'block',
          marginBottom: '2px',
        },
      }
   },
   created(){
   },
   computed:{
   },
   methods:{
   },
}
</script>
<style lang="less" scoped>
.page-box {
  background-color: #fff;
}
.top-banner-tips {
  font-size: 16px;
  color: #222222;
  line-height: 28px;
  margin-bottom: 24px;
  width: 638px;
}
.mg-btm-70 {
  margin-bottom: 70px;
}
.pd-bottom-100 {
  padding-bottom: 100px;
}
.mg-bottom-70 {
  margin-bottom: 70px;
}
.mg-bottom-110 {
  margin-bottom: 110px;
}
.pd-btm-70{
  padding-bottom: 70px;
}
.bg-color-EAF1FA {
  background-color: #EAF1FA;
}
.mg-bottom-100 {
  margin-bottom: 100px;
}
.pd-top-70 {
  padding-top: 70px;
}
.flex-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.goods-manage-ilne {
  display: flex;
  text-align: left;
  font-size: 14px;
  color: #595859;
  line-height: 22px;
  margin-bottom: 53px;
}
.item-ilne-icon {
  width: 22px;
  height: 16px;
  margin-right: 10px;
}
.item-ilne-title {
  display: inline-block;
  font-weight: bold;
  font-size: 22px;
  color: #222222;
  line-height: 22px;
  margin-bottom: 14px;
}
.item-ilne-content {
  width: 220px;
}
.goods-manage-mid-img {
  width: 600px;
}
.goods-manage-item {
  box-sizing: border-box;
  height: 430px;
  display: flex;
  flex-direction: column;
}
.core-advantages {
  padding: 71px 0 0 0;
}
.showImg {
  width: 100%;
  height: auto;
  margin-bottom: 100px;
}
.justify-center-start {
  justify-content: flex-start;
}
</style>
